"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/es");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Texto alternativo:"
  },
  announcement_list_da155734: {
    message: "Lista de Anuncios"
  },
  announcements_a4b8ed4a: {
    message: "Anuncios"
  },
  assignments_1e02582c: {
    message: "Tareas"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Color de fondo, pulse abajo para seleccionar"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Cancelar la carga de archivos"
  },
  cancel_image_upload_2c771950: {
    message: "Cancelar la carga de im\xE1genes"
  },
  cc_attribution_f6de631f: {
    message: "Atribuci\xF3n de CC"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "Atribuci\xF3n sin derivativos de CC"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "Atribuci\xF3n no comercial de CC"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "Atribuci\xF3n no comercial sin derivativos de CC"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "Atribuci\xF3n no comercial compartida de CC"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "Atribuci\xF3n compartida de CC"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Compruebe si la imagen es decorativa"
  },
  choose_usage_rights_33683854: {
    message: "Elegir derechos de uso..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Hacer clic en cualquier archivo para insertar un enlace descargado para ese archivo."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Hacer clic en cualquier imagen para insertar la imagen en la p\xE1gina."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Haga clic en cualquier p\xE1gina para insertar un enlace a esa p\xE1gina."
  },
  click_to_embed_image_33107dd8: {
    message: "Haga clic para inclu\xEDr imagen"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Haga clic para inclu\xEDr { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Haz clic para insertar un enlace en el editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Haz clic para insertar un enlace a este elemento."
  },
  close_flickr_form_b32e600a: {
    message: "Formulario Cerrar Flickr"
  },
  collaborations_5c56c15f: {
    message: "Colaboraciones"
  },
  copyright_holder_66ee111: {
    message: "Titular de los derechos de autor:"
  },
  course_navigation_dd035109: {
    message: "Navegaci\xF3n del Curso"
  },
  creative_commons_license_725584ae: {
    message: "Licencia Creative Commons:"
  },
  decorative_image_fde98579: {
    message: "Imagen decorativa"
  },
  discussions_a5f96392: {
    message: "Foros"
  },
  discussions_index_6c36ced: {
    message: "\xCDndice de Foros"
  },
  embed_image_1080badc: {
    message: "Incorporar imagen"
  },
  enter_search_terms_e397b1f0: {
    message: "ingresar los t\xE9rminos de b\xFAsqueda"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Ingrese el texto alternativo para esta imagen"
  },
  file_upload_form_4aaad554: {
    message: "Formulario Cargar archivos"
  },
  files_c300e900: {
    message: "Archivos"
  },
  files_index_af7c662b: {
    message: "\xCDndice de Archivos"
  },
  folder_705fd2d7: {
    message: "Carpeta"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Tama\xF1o del texto, pulse abajo para seleccionar"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formato, pulse abajo para seleccionar"
  },
  grades_a61eba0a: {
    message: "Calificaciones"
  },
  group_navigation_99f191a: {
    message: "Navegaci\xF3n del Grupo"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "He obtenido permiso para utilizar este archivo."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Soy el titular de los derechos de autor"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Si no selecciona los derechos de uso en este momento, se cancelar\xE1 la publicaci\xF3n de este archivo despu\xE9s de cargarlo."
  },
  image_upload_form_7b74079a: {
    message: "Formulario Cargar im\xE1genes"
  },
  images_7ce26570: {
    message: "Imagenes"
  },
  insert_equella_links_49a8dacd: {
    message: "Insertar enlaces de Equella"
  },
  insert_link_6dc23cae: {
    message: "Insertar enlace"
  },
  insert_math_equation_57c6e767: {
    message: "Insertar la ecuaci\xF3n matem\xE1tica"
  },
  link_7262adec: {
    message: "Enlace"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Enlazar a una nueva p\xE1gina"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Enlazar a otro contenido en el curso."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Enlazar a otro contenido en el grupo."
  },
  link_to_url_52dd935c: {
    message: "URL del enlace"
  },
  links_14b70841: {
    message: "Enlaces"
  },
  load_more_results_460f49a9: {
    message: "Cargar m\xE1s resultados"
  },
  loading_25990131: {
    message: "Cargando..."
  },
  loading_failed_b3524381: {
    message: "La carga fall\xF3..."
  },
  loading_folders_8d4d5d5a: {
    message: "CarCargando carpetas..."
  },
  modules_c4325335: {
    message: "M\xF3dulos"
  },
  no_results_940393cf: {
    message: "No hay resultados."
  },
  pages_e5414c2c: {
    message: "P\xE1ginas"
  },
  people_b4ebb13c: {
    message: "Personas"
  },
  quizzes_7e598f57: {
    message: "Evaluaciones"
  },
  record_upload_media_5fdce166: {
    message: "Grabar/cargar medios"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Area del texto enriquecido. Presione ALT+F8 para ayuda"
  },
  search_280d00bd: {
    message: "Buscar"
  },
  search_flickr_6884b518: {
    message: "Buscar Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Seleccione un archivo"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Seleccione una carpeta en donde guardar el archivo cargado"
  },
  syllabus_f191f65b: {
    message: "Programa"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Color de texto, pulse abajo para seleccionar"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "El material es de dominio p\xFAblico"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "El material tiene licencia Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "El material est\xE1 sujeto a la excepci\xF3n de uso razonable"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Esta carga supera el cupo de almacenamiento de archivos. Comun\xEDquese con el administrador del sistema."
  },
  upload_8b403d05: {
    message: "Cargar"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Cargar un Archivo Nuevo"
  },
  upload_a_new_image_890df275: {
    message: "Cargar una imagen nueva"
  },
  usage_right_ff96f3e2: {
    message: "Derecho de uso:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "\xBFC\xF3mo le gustar\xEDa llamar a la p\xE1gina nueva?"
  },
  wiki_home_9cd54d0: {
    message: "P\xE1gina de Inicio de Wiki"
  }
};

_formatMessage.default.addLocale({
  es: locale
});